// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'clock-sla';

export const Component = () => (
  <path d='M25 12.5a12.5 12.5 0 0 1-21.878 8.266.5.5 0 0 1 .75-.662A11.508 11.508 0 1 0 1.928 8H4.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v3.116A12.496 12.496 0 0 1 25 12.5zM12.5 6a.5.5 0 0 0-.5.5v6.002a.496.496 0 0 0 .142.346l.004.005 4 4a.5.5 0 0 0 .707-.707L13 12.293V6.5a.5.5 0 0 0-.5-.5z' />
);

export const viewBox = '0 0 25 25';
